import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiQuote } = FiIcons;

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Priya Patel',
      role: 'Yoga Instructor',
      // Female Portrait
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=150',
      rating: 5,
      text: 'After my knee injury, I thought my yoga days were over. The team at DIP helped me not only recover but come back stronger.',
      condition: 'Knee Injury Recovery'
    },
    {
      name: 'Rahul Sharma',
      role: 'Software Engineer',
      // Male Portrait
      image: 'https://images.unsplash.com/photo-1566492031773-4f4e44671857?auto=format&fit=crop&q=80&w=150',
      rating: 5,
      text: 'Years of desk work gave me chronic back pain. The personalized treatment plan changed my daily life.',
      condition: 'Chronic Back Pain'
    },
    {
      name: 'Anjali Desai',
      role: 'Teacher',
      // Female Portrait
      image: 'https://images.unsplash.com/photo-1589156280159-27698a70f29e?auto=format&fit=crop&q=80&w=150',
      rating: 5,
      text: 'DIP\'s hands-on approach got me back to full function faster than I expected.',
      condition: 'Shoulder Rehabilitation'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10 md:mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our Patients <span className="text-emerald-600"> Say</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Real stories from real patients in Surat.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-all duration-300 relative border border-transparent hover:border-emerald-100"
            >
              <div className="absolute top-4 right-4 text-emerald-100">
                <SafeIcon icon={FiQuote} className="w-8 h-8" />
              </div>

              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="w-4 h-4 md:w-5 md:h-5 text-yellow-400 fill-current" />
                ))}
              </div>

              <p className="text-gray-700 mb-6 leading-relaxed italic text-sm md:text-base">
                "{testimonial.text}"
              </p>

              <div className="mb-4">
                <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-xs md:text-sm font-medium">
                  {testimonial.condition}
                </span>
              </div>

              <div className="flex items-center">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name} 
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover mr-4 border-2 border-emerald-50" 
                />
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm md:text-base">{testimonial.name}</h4>
                  <p className="text-xs md:text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Stats Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="mt-12 md:mt-16 bg-white rounded-xl shadow-lg p-6 md:p-8 border-t-4 border-emerald-500"
        >
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            <div className="p-2 hover:bg-slate-50 rounded-lg transition-colors">
              <div className="text-2xl md:text-3xl font-bold text-emerald-600 mb-1 md:mb-2">500+</div>
              <div className="text-sm md:text-base text-gray-600">Happy Patients</div>
            </div>
            <div className="p-2 hover:bg-slate-50 rounded-lg transition-colors">
              <div className="text-2xl md:text-3xl font-bold text-emerald-600 mb-1 md:mb-2">4.9★</div>
              <div className="text-sm md:text-base text-gray-600">Average Rating</div>
            </div>
            <div className="p-2 hover:bg-slate-50 rounded-lg transition-colors">
              <div className="text-2xl md:text-3xl font-bold text-emerald-600 mb-1 md:mb-2">95%</div>
              <div className="text-sm md:text-base text-gray-600">Success Rate</div>
            </div>
            <div className="p-2 hover:bg-slate-50 rounded-lg transition-colors">
              <div className="text-2xl md:text-3xl font-bold text-emerald-600 mb-1 md:mb-2">98%</div>
              <div className="text-sm md:text-base text-gray-600">Would Recommend</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;